import { motion } from "framer-motion";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-plum border-t border-gold/15 py-14"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8"
        >
          <div className="flex items-center gap-4">
            <span className="w-10 h-10 border border-gold/60 flex items-center justify-center font-serif text-gold text-lg tracking-wider">
              FYA
            </span>
            <div className="flex flex-col leading-tight">
              <span className="font-serif text-cream text-sm tracking-[0.25em]">
                FATIMA ABDALLAH
              </span>
              <span className="text-cream/50 text-[10px] tracking-[0.3em] uppercase mt-1">
                Connecting People · Property · Possibility
              </span>
            </div>
          </div>

          <div className="flex items-center gap-8 text-[10px] tracking-[0.3em] uppercase text-cream/50">
            <a href="#about" className="hover:text-gold transition-colors">
              About
            </a>
            <a href="#services" className="hover:text-gold transition-colors">
              How I Help
            </a>
            <a href="#connect" className="hover:text-gold transition-colors">
              Connect
            </a>
          </div>
        </motion.div>

        <div className="gold-divider mt-12 mb-8 opacity-40" />

        <div className="mb-6 text-[10px] tracking-[0.3em] uppercase text-cream/40 flex flex-wrap items-center gap-x-3 gap-y-1">
          <span>Founder & Clinical Director</span>
          <a
            href="https://www.youarethefocuscommunitycare.com.au/"
            target="_blank"
            rel="noreferrer"
            data-testid="yatf-link-footer"
            className="text-gold/80 hover:text-gold link-underline transition-colors"
          >
            You Are The Focus Community Care
          </a>
          <span className="text-cream/30">·</span>
          <span>Behaviour Support · Allied Health · Therapeutic Services</span>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] tracking-[0.3em] uppercase text-cream/40">
          <span>© {year} Fatima Abdallah. All rights reserved.</span>
          <span>FYA Property Group · Strategic Property & Disability Housing Advisor · Queensland · National</span>
        </div>
      </div>
    </footer>
  );
}
